import PolicyLink from "../../components/PolicyLink";

export default function STBHome({darkMode}) {
    return (
        <div className={`flex flex-col items-center ${darkMode ? 'dark' : ''}`}>
            <h2 className='font-bold text-center'>Shut the Box Daily</h2>
            <h3>Screenshots</h3>
            <div className="flex flex-row flex-wrap">
                <img className="m-2 w-36" alt="app screenshot" src="/stb-daily-screens/1.png" />
                <img className="m-2 w-36" alt="app screenshot" src="/stb-daily-screens/2.png" />
                <img className="m-2 w-36" alt="app screenshot" src="/stb-daily-screens/3.png" />
            </div>
            <h3>Contact Form</h3>
            <div className="flex h-[750px] w-full">
                <iframe title="support form" src="https://docs.google.com/forms/d/e/1FAIpQLSeyQMHrZ7075WvWHjP0YJgg63bQxp4Cpc6_dpNxAu98E_Z6Nw/viewform?embedded=true" width="100%" height="700">Loading…</iframe>
            </div>
            <PolicyLink url={"https://www.termsfeed.com/live/527b90d7-be28-4e15-a89d-d50b7c473d29"} />
        </div>
    )
}
